import { Link } from 'react-router-dom';
import Avatar from 'react-avatar';
import { isMobile } from "react-device-detect";
import React from "react";

function itemDetailsPageLink(item) {
    const baseURL = process.env.NODE_ENV === "production" ? "https://piano-piano.org/oppdb" : "http://localhost:8000"
    return `${baseURL}/work/${item.id}${'/'}${item?.title}`
    // return `${"/work/"}${item.id}${'/'}${item?.title}`
}

const ItemWork = ({ item }) => {

    return (
        <div key={item.id} id="bgblur" className="m-8 p-4 px-5 mx-auto rounded-xl shadow-lg hover:shadow-2xl border border-l-4 border-gray-400">
            <div className="flex flex-col w-full mb-2">
                <a target="_blank" href={itemDetailsPageLink(item)} className="text-xl sm:text-2xl font-semibold title-font mb-4 text-gray-700 hover:text-pblue capitalize">{item.title}</a>
                <div className="space-y-1.5">
                    <p className="mx-auto leading-relaxed text-gray-600 text-md py-1 capitalize">{item?.mouvement?.substr(0, 170)}</p>

                    <p className="leading-relaxed text-sm"><span className="font-medium">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="inline w-4 h-4 mr-1 text-pblue mb-1">
                            <path d="M7.5 3.375c0-1.036.84-1.875 1.875-1.875h.375a3.75 3.75 0 013.75 3.75v1.875C13.5 8.161 14.34 9 15.375 9h1.875A3.75 3.75 0 0121 12.75v3.375C21 17.16 20.16 18 19.125 18h-9.75A1.875 1.875 0 017.5 16.125V3.375z" />
                            <path d="M15 5.25a5.23 5.23 0 00-1.279-3.434 9.768 9.768 0 016.963 6.963A5.23 5.23 0 0017.25 7.5h-1.875A.375.375 0 0115 7.125V5.25zM4.875 6H6v10.125A3.375 3.375 0 009.375 19.5H16.5v1.125c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 013 20.625V7.875C3 6.839 3.84 6 4.875 6z" />
                        </svg>Publisher </span>: {item?.publisher}
                    </p>

                    <p className="leading-relaxed text-sm"><span className="font-medium">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="inline w-4 h-4 mr-1 text-pblue mb-1">
                            <path fillRule="evenodd" d="M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
                        </svg>
                        Type </span>: {item?.typeChoosen}
                    </p>

                    {item?.dateOfPublication &&
                        <p className="leading-relaxed text-sm"><span className="font-medium">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="inline w-4 h-4 mr-1 text-pblue mb-1">
                                <path fillRule="evenodd" d="M8.603 3.799A4.49 4.49 0 0112 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 013.498 1.307 4.491 4.491 0 011.307 3.497A4.49 4.49 0 0121.75 12a4.49 4.49 0 01-1.549 3.397 4.491 4.491 0 01-1.307 3.497 4.491 4.491 0 01-3.497 1.307A4.49 4.49 0 0112 21.75a4.49 4.49 0 01-3.397-1.549 4.49 4.49 0 01-3.498-1.306 4.491 4.491 0 01-1.307-3.498A4.49 4.49 0 012.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 011.307-3.497 4.49 4.49 0 013.497-1.307zm7.007 6.387a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
                            </svg>Date of publication </span>: {item?.dateOfPublication}
                        </p>
                    }
                </div>
            </div>
            <div className="flex flex-row justify-between">
                <div className="flex flex-row items-center space-x-4 my-4">
                    <div className="bg-contain bg-top">
                        <Avatar name={item?.firstName ? item.firstName : 'N'} className="font-bold" round={true} size={isMobile ? "40" : "50"} />
                    </div>
                    <div className="flex flex-col space-y-1">
                        <span className="font-medium">
                            {item.firstName} {item.lastName}
                        </span>
                        {item?.dateOfComposition &&
                            <div className="flex flex-row space-x-2">
                                <span className="text-sm italic text-gray-500"> Written in  </span>
                                <span className="text-sm font-medium text-gray-700">{item?.dateOfComposition}</span>
                            </div>
                        }
                    </div>
                </div>
                <div className="space-x-4 border-t md:border-t-0 pt-4 transform hover:-translate-y-1">
                    <a target="_blank" href={itemDetailsPageLink(item)} className="flex flex-row items-center px-6 py-1 bg-blue-700 rounded-lg text-sm font-medium border-white text-white ">
                        Read
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3" />
                        </svg>
                    </a>
                </div>
            </div>

        </div>
    )
}

export default ItemWork;